"use client";

import { CMSModal } from "@/context";
import { useMeQuery } from "@/graphql/generated/schema";
import { useRouter } from "next/navigation";
import React, { useContext, useEffect } from "react";

const Auth = ({ children }: { children: React.ReactNode }) => {
  const { data, loading } = useMeQuery({
    fetchPolicy: "cache-first",
    pollInterval: 100000,
  });
  const router = useRouter();
  const { setUser } = useContext(CMSModal);

  useEffect(() => {
    if (!loading && !data?.me) {
      router.replace("/login");
    }
  }, [loading, data, router]);

  // ✅ Set user only after data is available
  useEffect(() => {
    if (data?.me) {
      setUser(data.me);
    }
  }, [data, setUser]);

  if (!data?.me) return null;

  return <>{children}</>;
};

export default Auth;
